import React, { memo, PropsWithChildren } from 'react';
import { Redirect } from 'react-router-dom';
import { Session } from '@modules/auth/session';
import { LazyRoute, LazyRouteProps } from './LazyRoute';
import { UserRole } from '@business/entities/account';

export const PrivateRoute = memo((props: PropsWithChildren<LazyRouteProps> & { roles?: UserRole[] }) => {
  return <LazyRoute {...props} guard={() => guardPrivateRoute(props.roles)} />;
});

export const PublicRoute = memo((props: PropsWithChildren<LazyRouteProps>) => {
  //   return <LazyRoute {...props} guard={guardPublicRoute} />;
  return <LazyRoute {...props} />;
});

export const PublicPageRoute = memo((props: PropsWithChildren<LazyRouteProps>) => {
  return <LazyRoute {...props} />;
});

function guardPrivateRoute(roles?: UserRole[]) {
  //   if (Session.isAuthenticated && Session.user && roles && roles.indexOf(Session.user.role) == -1) {
  //     return <Redirect to="/401" />;
  //   }

  return Session.isAuthenticated ? null : (
    <Redirect
      to={{
        pathname: '/login',
        search: 'redirectUrl=' + encodeURIComponent(window.location.href.replace(window.location.protocol + '//' + window.location.host, '')),
      }}
    />
  );
}
